import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AlertService } from '../../../../../core/services/alert/alert.service';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'app-modal-approval-links',
    imports: [MatIconModule, MatDialogModule],
    templateUrl: './modal-approval-links.component.html',
    styleUrl: './modal-approval-links.component.scss'
})
export class ModalApprovalLinksComponent {
  showCloseAlert = false;
  links!: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ModalApprovalLinksComponent>, private alert: AlertService) {}

  ngOnInit(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    this.links = receivedData?.links;
    if (!this.links) return this.closeModal();
  }

  async confirmCloseModal(): Promise<any> {
    if (this.showCloseAlert) {
      const closeModal = await this.alert.presentCloseWindowAlert();
      return closeModal ? this.closeModal() : null;
    }

    this.closeModal();
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }
}
